module.exports = __webpack_public_path__ + "img/figuur01.d18ab65b.png";